module.exports = __webpack_public_path__ + "img/点赞.ef1438be.png";